import FieldValidator from './_FieldValidator';

export default class RegexFieldValidator extends FieldValidator {
    regex;
    constructor(message, pattern) {
        super(message);

        this.regex = new RegExp(pattern);
    }

    async validate(value) {
        if (this.regex.test(value)) {
            return Promise.resolve({ valid: true });
        }

        return Promise.resolve({ valid: false, messages: [{ text: this.message }] });
    }
}